/** Copyright ©2026 Devexperts LLC.
All rights reserved. Any unauthorized use will constitute an infringement of copyright.
In case of any questions regarding types of use, please contact legal@devexperts.com.
This notice must remain intact.
**/
const DEFAULT_VOLATILITY=0.05;export function*createPriceDiffGenerator(a={}){const b=a['volatility']??DEFAULT_VOLATILITY,c=0x1-b/0x2;for(;;){yield c+b*Math['random']();}}